import React from 'react';
import ListsCard from '@/components/lists/Card';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ChartEditorGuide = _ref => {
  let {
    isWorkbookSetup,
    isChartSetup,
    onConnectWidgetData = () => null,
    onChartSelect = () => null
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx("h5", {
      className: styles.title,
      children: "Select an option to get started"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.options,
      children: [!isWorkbookSetup ? /*#__PURE__*/_jsx(ListsCard, {
        className: styles.option,
        onClick: onConnectWidgetData,
        imgSrc: "/img/pages/widgets/widget-data.svg",
        title: "Connect Data",
        description: "Setup data by uploading a file, syncing from drive, or using existing data."
      }) : null, !isChartSetup ? /*#__PURE__*/_jsx(ListsCard, {
        className: styles.option,
        imgSrc: "/img/pages/widgets/widget-design.webp",
        title: "Select Chart",
        description: "Select a chart type to begin visualizing your data.",
        onClick: onChartSelect
      }) : null]
    })]
  });
};

export default ChartEditorGuide;